import "./App.css";
import Main from "./main/Main"
import Header from "./Component/Header/Header";

function App() {
  return (
    <div className="App">
      <Header/>
      <Main />
    </div>
  );
}

export default App;
